// import React, { useState, useEffect } from "react";
// import { useUser } from "../config/userProvider";
// import { IoHelp, IoPowerSharp, IoSettingsOutline } from "react-icons/io5";
// import { RxHamburgerMenu } from "react-icons/rx";
// import { removeCookie } from "../config/webStorage.js";
// import { useNavigate, NavLink } from "react-router-dom";
// import moment from "moment";
// import { GoBell } from "react-icons/go";
// import { IoSearch } from "react-icons/io5";
// import Notification from "./notification.js";
// import axios from "axios";
// import { apiurl } from "../config/config";
// import { CgProfile } from "react-icons/cg";
// import { Grip } from "lucide-react";
// import Portals from "./portals.js";

// const AdminHeader = () => {
//   // const [selectedCountry, setSelectedCountry] = useState("");
//   // const countries = [
//   //   "India",
//   //   "United States",
//   //   "Canada",
//   //   "Australia",
//   //   "Germany",
//   // ];
//   // const handleChange = (e) => {
//   //   setSelectedCountry(e.target.value);
//   // };
//   const {
//     openProfile,
//     setCloseProfile,
//     userData,
//     isMenuOpen,
//     setIsMenuOpen,
//     showSearch,
//     setShowSearch,
//   } = useUser();
//   const [openSearch, setOpenSearch] = useState(false);
//   const navigate = useNavigate();
//   const logOutHandler = () => {
//     removeCookie("swtoken");
//     window.location.reload();
//     navigate("/");
//   };
//   const [message, setMessage] = useState({ type: "", message: "" });

//   const verificationDetails = userData?.verificationDetails;
//   const Verification =
//     ((userData?.userType === "admin" || userData?.userType === "user") &&
//       !userData?.storeDetails?.storeObjId) ||
//     (userData?.storeDetails?.storeObjId &&
//       verificationDetails?.isEmailVerified);

//   console.log("userData", Verification);
//   const FormattedDate = () => {
//     const currentDate = moment(); // Get the current date and time
//     const formattedDate = currentDate.format("dddd, DD MMMM YYYY");

//     return <span>{formattedDate}</span>;
//   };

//   const [isNotificationCartOpen, setIsNotificationCartOpen] = useState(false);

//   // Function to toggle component visibility
//   const notificationCartHandle = () => {
//     setIsNotificationCartOpen(!isNotificationCartOpen);
//   };
//   // const notificationCartHandle = () => {
//   //   setIsNotificationCartOpen((prev) => !prev);
//   // };

//   const [unreadCount, setUnreadCount] = useState(0);
//   const [notifications, setNotifications] = useState([]);

//   const [showPortals, setShowPortals] = useState(false);

//   const fetchNotifications = async () => {
//     try {
//       const response = await axios.post(
//         `${apiurl}/admin/v1/notifications/user`,
//         // JSON.stringify({ userObjId: "67401dbcb258c964b7567dc6" }),
//         JSON.stringify({ userObjId: userData?._id }),
//         { headers: { "Content-Type": "application/json" } }
//       );

//       if (response.data.success) {
//         const notifications = response.data.data;
//         setNotifications(notifications);

//         // Count unread notifications
//         const unread = response?.data?.unread;
//         // const unread = notifications.filter((n) => !n.isRead).length;
//         setUnreadCount(unread);
//       }
//     } catch (error) {
//       console.error("Failed to fetch notifications:", error);
//     }
//   };

//   useEffect(() => {
//     fetchNotifications();
//   }, []);

//   return (
//     <div
//       className={`bg-white px-3 py-3 flex items-center justify-between w-full border-b border-slate-200`}
//     >
//       <div className="py-2 md:hidden block cursor-pointer">
//         <RxHamburgerMenu onClick={() => setIsMenuOpen(true)} />
//       </div>
//       <div className="md:flex gap-2 items-center hidden">
//         <div>
//           <h1 className="text-xs md:text-sm lg:text-lg font-medium capitalize hidden md:block">
//             Hi, {userData?.firstName} {userData?.lastName}
//           </h1>
//           <p className="text-zinc-400 text-[0.55rem]">
//             Today is {FormattedDate()}
//           </p>
//         </div>
//       </div>
//       {/* <div className="md:hidden " onClick={() => setShowSearch(true)}>
//         <IoSearch className="" />
//       </div> */}
//       <div className="md:hidden">
//         <img src="/suwasthi-logo-brown.png" className="h-12 md:h-16" />
//       </div>

//       {/* {message?.type === "error" && <Error err={message?.message} />} */}
//       <div className="flex items-center gap-2 lg:gap-4 relative">
//         <div className="hidden md:flex items-center gap-4">
//           <button
//             className="bg-zinc-100 w-8 h-8 lg:w-10 lg:h-10 border rounded-full text-xs md:text-base lg:text-xl relative flex items-center justify-center"
//             onClick={notificationCartHandle}
//           >
//             {unreadCount > 0 && (
//               <span className="absolute bg-red-500 text-white text-[0.6rem] md:text-sm font-bold rounded-full sm:w-4 w-3 sm:h-4 h-3 flex items-center justify-center md:right-2 sm:top-2 top-1 right-1  md:top-1">
//                 {unreadCount}
//               </span>
//             )}

//             <GoBell className="text-gray-800 text-xl md:text-2xl" />
//           </button>
//         </div>
//         <div className="capitalize h-8 bg-blue-50 border-[1px] border-blue-200 rounded-md hidden md:block py-1 px-2 md:px-4 text-blue-500 items-center justify-center">
//           <span className="text-sm font-medium uppercase">
//             {userData?.role || "No Role"}
//           </span>
//         </div>
//         <div className=" hidden md:block cursor-pointer">
//           <Grip
//             className="text-gray-800"
//             onClick={() => setShowPortals(true)}
//           />
//         </div>

//         {showPortals && (
//           <Portals user={userData} onClose={() => setShowPortals(false)} />
//         )}
//         <div
//           className="uppercase bg-zinc-100 rounded-full w-7 h-7 lg:w-9 lg:h-9 border border-[#d8c9ae]  overflow-hidden cursor-pointer flex justify-center items-center"
//           onClick={() => setCloseProfile(!openProfile)}
//         >
//           <span className="text-l">
//             {userData?.firstName.charAt(0) || (
//               <CgProfile className="text-slate-400" />
//             )}
//           </span>
//         </div>

//         {openProfile && (
//           <div className="absolute shadow-sm text-sm right-0 top-[100%] bg-white/100  z-20 p-2 px-4 mt-2 rounded-md capitalize whitespace-pre">
//             <NavLink to="/account">
//               <div className="flex items-center gap-2 cursor-pointer border-b border-transparent  hover:border-zinc-100 py-1 ">
//                 <IoSettingsOutline />
//                 account & settings
//               </div>
//             </NavLink>
//             <div
//               className="mt-3 text-red-500 flex items-center  gap-2 cursor-pointer"
//               onClick={logOutHandler}
//             >
//               <IoPowerSharp />
//               logout
//             </div>
//           </div>
//         )}
//       </div>

//       {isNotificationCartOpen && (
//         <Notification
//           notifications={notifications}
//           onClose={notificationCartHandle}
//         />
//       )}
//     </div>
//   );
// };

// export default AdminHeader;





import React, { useState, useEffect, useCallback } from "react";
import { useUser } from "../config/userProvider";
import { IoPowerSharp, IoSettingsOutline, IoSearch } from "react-icons/io5";
import { RxHamburgerMenu } from "react-icons/rx";
import { removeCookie } from "../config/webStorage.js";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import moment from "moment";
import { GoBell } from "react-icons/go";
import Notification from "./notification.js";
import axios from "axios";
import { apiurl } from "../config/config";
import { CgProfile } from "react-icons/cg";
import { Grip, Search } from "lucide-react";
import Portals from "./portals.js";
import SearchModal from "./searchPopup.js";

/**
 * AdminHeader — improved
 *
 * Notes:
 * - Requires useUser() to expose:
 *   { openProfile, setCloseProfile, userData, isMenuOpen, setIsMenuOpen, showSearch, setShowSearch }
 * - If your provider names differ (eg. setOpenProfile vs setCloseProfile) adjust accordingly.
 */

const FormattedDate = () => {
  const currentDate = moment();
  return <span>{currentDate.format("dddd, DD MMMM YYYY")}</span>;
};

const AdminHeader = () => {
  const {
    openProfile,
    setCloseProfile, // keep using your provider API naming
    userData,
    isMenuOpen,
    setIsMenuOpen,
    showSearch,
    setShowSearch,
  } = useUser();

  const [isNotificationCartOpen, setIsNotificationCartOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [showPortals, setShowPortals] = useState(false);
  const [message, setMessage] = useState({ type: "", message: "" });

  const location = useLocation();

    const hideSearch =
    location.pathname.includes("/payroll") ||
    location.pathname.includes("/sales");

  const navigate = useNavigate();

  // Logout: clear token & navigate to home/login
  const logOutHandler = useCallback(() => {
    try {
      removeCookie("swtoken");
    } catch (e) {
      console.warn("Failed to remove cookie:", e);
    }
    // Prefer navigation without full reload — preserves SPA behavior
    navigate("/");
    // If you want to force a full reload uncomment next line:
    // window.location.reload();
  }, [navigate]);

  // Toggle notification panel
  const notificationCartHandle = useCallback(() => {
    setIsNotificationCartOpen((prev) => !prev);
  }, []);

  // Fetch notifications when userData._id becomes available
  const fetchNotifications = useCallback(async (userId) => {
    if (!userId) return;
    try {
      const response = await axios.post(
        `${apiurl}/admin/v1/notifications/user`,
        JSON.stringify({ userObjId: userId }),
        { headers: { "Content-Type": "application/json" } }
      );

      if (response?.data?.success) {
        const data = response.data.data || [];
        setNotifications(data);

        // backend may return unread as number or compute it here as fallback
        const unreadFromResponse = response.data.unread;
        if (typeof unreadFromResponse === "number") {
          setUnreadCount(unreadFromResponse);
        } else {
          const computed = data.filter((n) => !n.isRead).length;
          setUnreadCount(computed);
        }
      } else {
        // gracefully handle if success=false
        setNotifications([]);
        setUnreadCount(0);
      }
    } catch (error) {
      console.error("Failed to fetch notifications:", error);
    }
  }, []);

  // initial fetch & refetch when user id changes
  useEffect(() => {
    if (!userData?._id) return;
    fetchNotifications(userData._id);

    // Optional: poll for new notifications every 45s (enable if you like)
    // const id = setInterval(() => fetchNotifications(userData._id), 45000);
    // return () => clearInterval(id);
  }, [userData?._id, fetchNotifications]);

  // Click outside handling for profile & portals could be added (left out to keep simple).
  // Toggle portals
  const openPortals = () => setShowPortals(true);
  const closePortals = () => setShowPortals(false);

  // safe avatar letter
  const avatarLetter = userData?.firstName ? userData.firstName.charAt(0).toUpperCase() : "U";

  return (
    <header className="bg-white px-3 py-3 flex items-center justify-between w-full border-b border-slate-200">
      {/* mobile hamburger */}
      <div className="py-2 md:hidden block">
        <button
          aria-label="Open menu"
          title="Open menu"
          onClick={() => setIsMenuOpen(true)}
          className="p-1"
        >
          <RxHamburgerMenu className="text-lg" />
        </button>
      </div>

      {/* greeting + date (hidden on small screens) */}
      <div className="md:flex gap-2 items-center hidden">
        <div>
          <h1 className="text-xs md:text-sm lg:text-lg font-medium capitalize hidden md:block">
            Hi, {userData?.firstName || ""} {userData?.lastName || ""}
          </h1>
          <p className="text-zinc-400 text-[0.55rem]">
            Today is <FormattedDate />
          </p>
        </div>
      </div>

      {/* logo for small screens */}
      <div className="md:hidden">
        <img src="/suwasthi-logo-brown.png" className="h-12 md:h-16" alt="Suwasthi logo" />
      </div>

      {/* right-side controls */}
      <div className="flex items-center gap-2 lg:gap-4 relative">

      {/* <SearchModal/> */}

            {!hideSearch && <SearchModal />}
        {/* role badge */}
        <div className="capitalize h-8 bg-blue-50 border-[1px] border-blue-200 rounded-md hidden md:flex items-center px-3 text-blue-500">
          <span className="text-sm font-medium uppercase">{userData?.role || "No Role"}</span>
        </div>

        {/* portals icon */}
        <div className="hidden md:block">
          <button
            aria-label="Open portals"
            title="Portals"
            onClick={openPortals}
            className="p-1 rounded hover:bg-slate-50"
          >
            <Grip className="text-gray-800" />
          </button>
        </div>
        {showPortals && <Portals user={userData} onClose={closePortals} />}

                {/* notification bell (hidden on small screens) */}
        <div className="hidden md:flex items-center">
          <button
            className="bg-zinc-100 w-8 h-8 lg:w-10 lg:h-10 border rounded-full relative flex items-center justify-center"
            onClick={notificationCartHandle}
            aria-label="Notifications"
            title="Notifications"
          >
            {unreadCount > 0 && (
              <span
                className="absolute bg-red-500 text-white text-[0.6rem] font-bold rounded-full flex items-center justify-center"
                style={{ minWidth: 16, height: 16, top: 6, right: 6 }}
              >
                {unreadCount}
              </span>
            )}
            <GoBell className="text-gray-800 text-xl md:text-2xl" />
          </button>
        </div>


        {/* avatar */}
        <div
          className="uppercase bg-zinc-100 rounded-full w-7 h-7 lg:w-9 lg:h-9 border border-[#d8c9ae] overflow-hidden cursor-pointer flex justify-center items-center"
          onClick={() => setCloseProfile(!openProfile)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") setCloseProfile(!openProfile);
          }}
        >
          <span className="text-l">{avatarLetter}</span>
        </div>

        {/* profile dropdown */}
        {openProfile && (
          <div
            className="absolute shadow-sm text-sm right-0 top-[100%] bg-white z-20 p-2 px-4 mt-2 rounded-md capitalize whitespace-pre"
            role="dialog"
            aria-label="Profile menu"
          >
            <NavLink to="/account" onClick={() => setCloseProfile(false)}>
              <div className="flex items-center gap-2 cursor-pointer border-b border-transparent hover:border-zinc-100 py-1">
                <IoSettingsOutline />
                <span>account & settings</span>
              </div>
            </NavLink>

            <div
              className="mt-3 text-red-500 flex items-center gap-2 cursor-pointer"
              onClick={logOutHandler}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && logOutHandler()}
            >
              <IoPowerSharp />
              <span>logout</span>
            </div>
          </div>
        )}
      </div>

      {/* notification cart */}
      {isNotificationCartOpen && (
        <Notification
          notifications={notifications}
          onClose={notificationCartHandle}
          setUnreadCount={setUnreadCount} // optionally allow Notification to mark read
        />
      )}
    </header>
  );
};

export default AdminHeader;

